import { getCarEBoxLocations } from './getCarEBoxLocations';
import { resetCarEBoxLocations } from './resetCarEBoxLocations';
import { resetSelectedCarEBoxLocation } from './resetSelectedCarEBoxLocation';
import { resetSelectedCar } from './resetSelectedCar';
import { updateSelectedCar } from './updateSelectedCar';

export const carOperations = {
  getCarEBoxLocations,
  resetCarEBoxLocations,

  resetSelectedCarEBoxLocation,
  updateSelectedCar,
  resetSelectedCar
};
